import React, { useContext } from 'react'
import './styles.scss'

import Auth from './steps/Auth'
import CellPhoneValidation from './steps/CellPhoneValidation'
import CPFRegister from './steps/CPFRegister'
import TenantRegister from './steps/TenantRegister'
import BankData from './steps/BankData'
import ImmobileData from './steps/ImmobileData'
import NegotiatedConditions from './steps/NegotiatedConditions'
import PaydaySelect from './steps/PaydaySelect'
import ContractDuration from './steps/ContractDuration'
import Review from './steps/Review'
// import PaymentAndWarranty from './steps/PaymentAndWarranty'
import WarrantyDetails from './steps/WarrantyDetails'
import NumberOfDeposits from './steps/NumberOfDeposits'

import VerticalStep from '../../../components/VerticalStep'
import contractContext from '../../../store/contexts/contractContext'
import COLORS from 'styles/colors'

const withUrlData = (WrappedComponent, urlData) => {
  return () => <WrappedComponent urlData={urlData} />
}

export default function CreateContract({ urlData }) {
  const { currentStep, handleStepChange, isLoading } = useContext(contractContext)

  return (
    <div className='create-contract-steps'>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 24,
        border: `1px solid ${COLORS.brand.primary}`,
        borderRadius: 4,
        padding: '16px 8px',
        fontSize: 14,
      }}>
        <div style={{ display: 'flex', marginRight: 16 }}>
          <span role='img' aria-label='warning' style={{ marginRight: 4 }}>
            ⚠️
          </span>
          <p>
            Já verificou o CPF do seu inquilino?
          </p>
        </div>
        <span>
          <a
            href='https://welcome.mellro.com/credit'
            target='_blank'
            rel='noopener noreferrer'
          >
            Verifique aqui por R$ 25,00
          </a>
          {' '} antes de fechar o contrato!
        </span>
      </div>
      <VerticalStep
        selectedStep={currentStep}
        loading={isLoading}
        onClick={handleStepChange}
        steps={[
          {
            title: 'Entrar ou se Cadastrar',
            content: urlData ? withUrlData(Auth, urlData) : Auth,
            id: 'Auth',
          },
          {
            title: 'Validação do Celular',
            content: CellPhoneValidation,
            id: 'CellPhoneValidation',
          },
          {
            title: 'Dados do dono do Imóvel',
            content: CPFRegister,
            id: 'CPFRegister',
          },
          {
            title: 'Dados do morador',
            content: TenantRegister,
            id: 'TenantRegister',
          },
          {
            title: 'Seus dados bancários',
            content: BankData,
            id: 'BankData',
          },
          {
            title: 'Dados do imóvel',
            content: ImmobileData,
            id: 'ImmobileData',
          },
          {
            title: 'Condições negociadas',
            content: NegotiatedConditions,
            id: 'NegotiatedConditions',
          },
          {
            title: 'Detalhes sobre o seguro',
            content: WarrantyDetails,
            id: 'PaymentAndWarranty',
          },
          {
            title: 'Número de cauções',
            content: NumberOfDeposits,
            id: 'NumberOfDeposits',
          },
          {
            title: 'Entrada no imóvel & Vencimento do aluguel',
            content: PaydaySelect,
            id: 'PaydaySelect',
          },
          {
            title: 'Duração do contrato',
            content: ContractDuration,
            id: 'ContractDuration',
          },
          {
            title: 'Criar Contrato',
            content: Review,
            id: 'Review',
          },
        ]}
      />
    </div>
  )
}
